export default "__VITE_PUBLIC_ASSET__78ff6593__"